import client from '../client/client'

const getAllCollections = async () => {
  try {
    return await client.get('api/v1/admin/collection')
  } catch (error) {
    return error
  }
}

const createCollection = async (data: any) => {
  try {
    return await client.post('api/v1/admin/collection', data)
  } catch (error) {
    console.log('create Collection error', error)
    return error
  }
}

const updateCollection = async (data: any, id: string | number) => {
  try {
    return await client.put(`api/v1/admin/collection/${id}`, data)
  } catch (error) {
    console.log('update Collection error', error)
    return error
  }
}

export {
  getAllCollections,
  createCollection,
  updateCollection,
}

